import React from "react";
import Partner1 from "../assets/1200px-Msc_kreuzfahrten_logo 1.png" ;
import Partner2 from "../assets/171590209866469692511c6 1.png" ;
import Partner3 from "../assets/390NCL Logo (png) 1.png" ;
import Partner4 from "../assets/Celebrity-Cruises-Logo 1.png" ;
import Partner5 from "../assets//DLC_Upscaled 1.png" ;
import Partner6 from "../assets/images 1.png" ;
import Partner7 from "../assets/images 2.png" ;
import Partner8 from "../assets/24-Avalon.3c3453af.svg" ;
import Partner9 from "../assets/stardream.jpg" ;
import Partner10 from "../assets/8-Princess.8186270f.svg" ;
import Partner11 from "../assets/21-Silversea.66d05ac2.svg" ;
import Partner12 from "../assets/RCI_Brand_Logo_2-Line_Horiz_Navy_RGB.png" ;
import Partner13 from "../assets/logo.svg" ;
import Partner14 from "../assets/25-Uniworld.b1a8deca.svg" ;
import Partner15 from "../assets/cf-cruise-line-logo-antarctica-21-removebg-preview.png" ;



  const PartnerSlide = () => {


    return(
        <>
        <div className="slider-wrapper">
        <div className="partners slider-track">
            <img src={Partner1} alt="Partenr 1"/>
            <img src={Partner2} alt="Partenr 2"/>
            <img src={Partner3} alt="Partenr 3"/>
            <img src={Partner4} alt="Partenr 4"/>
            <img src={Partner5} alt="Partenr 5"/>
            <img src={Partner6} alt="Partenr 6" style={{height:'8vh', width:'14vh'}}/ >
            <img src={Partner7} alt="Partenr 7"/>
            <img src={Partner9} alt="Partenr 8" style={{height:'12vh', width:'15vh'}}/>

            <img src={Partner1} alt="Partenr 1"/>
            <img src={Partner2} alt="Partenr 2"/>
            <img src={Partner3} alt="Partenr 3"/>
            <img src={Partner4} alt="Partenr 4"/>
            <img src={Partner5} alt="Partenr 5"/>
            <img src={Partner6} alt="Partenr 6" style={{height:'8vh', width:'14vh'}}/>
            <img src={Partner7} alt="Partenr 7"/>
            <img src={Partner9} alt="Partenr 8"/>

         </div>
            <div className="partners slider-track2">
            <img src={Partner8} alt="Partenr 1"/>
            <img src={Partner10} alt="Partenr 3"/>
            <img src={Partner11} alt="Partenr 4"/>
            <img src={Partner12} alt="Partenr 5"/>
            <img src={Partner13} alt="Partenr 6" />
            <img src={Partner14} alt="Partenr 7"/>
            <img src={Partner15} alt="Partenr 1"/>
            <img src={Partner8} alt="Partenr 1"/>
            <img src={Partner10} alt="Partenr 3"/>
            <img src={Partner11} alt="Partenr 4"/>
            <img src={Partner12} alt="Partenr 5"/>
            <img src={Partner13} alt="Partenr 6" />
            <img src={Partner14} alt="Partenr 7"/>
            <img src={Partner15} alt="Partenr 1"/>

         </div>
        </div>
       
        </>
    );
  }


  export default PartnerSlide ;